import React, { useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './RegisterForm.css';

const RegisterForm = ({ onClose }) => {
  // Using the same Formspree ID
  const [state, handleSubmit] = useForm("mldbbwla");

  useEffect(() => {
    if (state.succeeded && window.gtag) {
      // This triggers the GA4 event, which Google Ads is now "listening" for
      window.gtag('event', 'conversion_event_signup', {
        'event_category': 'engagement',
        'event_label': 'FITZA Beta Sign-up',
        'value': 1.0,
        'currency': 'CAD'
      });

      console.log("🚀 FITZA SIGNUP Event Fired!");
    }
  }, [state.succeeded]);

  if (state.succeeded) {
    return (
      <div className="register-success">
        <div className="success-icon">🚀</div>
        <h2>You're on the list!</h2>
        <p>Thanks for joining the FITZA community. We'll notify you as soon as new vehicles and parts are ready for configuration.</p>
        <button className="view-store-link" onClick={onClose} style={{ width: '100%', marginTop: '20px', border: 'none' }}>
          Back to Garage
        </button>
      </div>
    );
  }

  return (
    <div className="register-form-container">
      <div className="register-header">
        <div className="badge">Coming Soon</div>
        <h2>Join the Early Access</h2>
        <p>We're building the ultimate off-road workshop. Get notified when we add:</p>
        <ul className="feature-list">
          <li>✨ New Trucks & SUVs</li>
          <li>🛠️ Premium Performance Parts</li>
          <li>💾 Save & Share Your Builds</li>
          <li>🏆 Community Showcases</li>
        </ul>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label htmlFor="reg-email">Email Address</label>
          <input
            type="email"
            id="reg-email"
            name="email"
            placeholder="name@example.com"
            required
          />
          <ValidationError
            prefix="Email"
            field="email"
            errors={state.errors}
            className="error-message"
          />
        </div>

        <div className="form-group">
          <label htmlFor="vehicle-request">What should we build next? (Optional)</label>
          <input
            type="text"
            id="vehicle-request"
            name="requested_build"
            placeholder="e.g., 2024 Ford Bronco"
          />
        </div>

        <button
          type="submit"
          className={`submit-btn ${state.submitting ? 'loading' : ''}`}
          disabled={state.submitting}
        >
          {state.submitting ? (
            <span className="spinner"></span>
          ) : 'Get Early Access'}
        </button>
        <p className="privacy-note">No spam. Only major updates and early access perks.</p>
      </form>
    </div>
  );
};

export default RegisterForm;
